import { animate, style, transition, trigger } from '@angular/animations';
import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { EstateControlService } from 'src/app/services/estate-control.service';
import { NotificationService } from 'src/app/services/notification.service';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { ModalComponent } from 'src/app/components/modal/modal.component';
import { decodeSessionData, hideEmailAddress, SessionData } from 'src/app/util/Helper';

@Component({
  selector: 'app-setup',
  templateUrl: './setup.component.html',
  styleUrls: ['./setup.component.scss'],
  animations: [
    trigger('slideIn', [
      transition(':enter', [
        style({ transform: 'translateX(-100%)', opacity: 0 }),
        animate('300ms', style({ transform: 'translateX(0)', opacity: 1 })),
      ]),
    ]),
  ]
})
export class SetupComponent implements AfterViewInit, OnInit {
  @ViewChild('modalContent') modalContent!: TemplateRef<any>;

  tabsAnimationState: boolean[] = [false, false, false, false];

  MileleLogoPath: string  = `${environment.hRef}assets/Milele_logo_white.png`;
  logoPath: string  = `${environment.hRef}assets/logo_w.png`;
  warnPath: string = `${environment.hRef}assets/warn.png`;
  powerdByText: string = 'Powered by ICEA LION Group. All rights reserved.';

  hasInfoPopupRun: boolean = false;
  otpEmail:string = 'that was used to set up the trust';

  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly dialog: MatDialog,
    private readonly notificationService: NotificationService,
    private readonly estateControlService: EstateControlService
  ) {
  }

  async ngOnInit(): Promise<void> {
    this.route.queryParams.subscribe(async (params) => {
      try {
        if (params["session"] == undefined) {
          await this.initLocal();
        } else {
          this.estateControlService.session = params["session"];
          await this.initResume(this.estateControlService.session);
        }
        
      } catch (error) {
        console.error('Estate Planning Resume! ', error);
      }

      if (this.estateControlService.planType === 0) this.estateControlService.showChecklist = true;
      else this.estateControlService.showChecklist = false;
    });
  }

  ngAfterViewInit() {
    // Trigger the animation for each tab after a slight delay
    this.animateTabs();
  }

  get regionType(): number {
    return this.estateControlService.regionType;
  }
  get session() {
    return this.estateControlService.session;
  }
  get planType() {
    return this.estateControlService.planType;
  }
  get loadingTab(): boolean {
    return this.notificationService.loadingTab;
  };
  get activeTab(): number {
    return this.estateControlService.activeTab;
  }

  get page1DoneEstate(): boolean {
    return this.estateControlService.page1Done;
  }
  get page2DoneEstate(): boolean {
    return this.estateControlService.page2Done;
  }
  get page3DoneEstate(): boolean {
    return this.estateControlService.page3Done;
  }
  get page4DoneEstate(): boolean {
    return this.estateControlService.page4Done;
  }
  get page5DoneEstate(): boolean {
    return this.estateControlService.page5Done;
  }
  get page6DoneEstate(): boolean {
    return this.estateControlService.page6Done;
  }
  get onlineStorageObject(): any {
    return this.estateControlService.onlineStorageObject;
  }

  animateTabs() {
    for (let i = 0; i < this.tabsAnimationState.length; i++) {
      setTimeout(() => {
        this.tabsAnimationState[i] = true;
      }, 400 * i); // Adjust the delay as needed
    }
  }
  // Type guard function to check if an object matches the SessionData type
  isSessionData(obj: any): obj is SessionData {
    return (
      typeof obj === 'object' &&
      obj !== null &&
      typeof obj.SessionId === 'string'
    );
  }

  async initLocal(onlineData: any = null): Promise<void> {
    const key = await this.estateControlService.getData(this.estateControlService.estateTypeKey);
    let data = await this.estateControlService.getData(key);
    if (onlineData) data = onlineData;

    if (data?.timeStamp) {
      const timeDiff = Date.now() - Number.parseInt(data.timeStamp);
      if (timeDiff > 86400000 ) {
        if (environment.production) await this.estateControlService.clearServiceRecords();
        if (this.activeTab == 1 && !this.hasInfoPopupRun) this.openInfoModal(); 
      } else {
        await this.estateControlService.updateDataFromStorage(data);
        
        if (this.estateControlService.TrustID) {
          if (this.estateControlService.planType === 0) this.estateControlService.showChecklist = true;
          else this.estateControlService.showChecklist = false;
        }
      }
    } else {
      if (this.activeTab == 1 && !this.hasInfoPopupRun) this.openInfoModal(); 
    }
  }
  async initResume(session: string): Promise<void> {
    const sessionData = decodeSessionData(session);
    if (this.isSessionData(sessionData) && sessionData.SessionId && sessionData.SessionId !== '') {
      await this.estateControlService.checkProgress(session);
      if (this.onlineStorageObject) {
        if (this.onlineStorageObject.planType == 0) {
          this.otpEmail = hideEmailAddress(this.onlineStorageObject.settlors[0].Email);
          this.estateControlService.showChecklist = true;
          
        } else {
          this.otpEmail = hideEmailAddress(this.onlineStorageObject.testators[0].Email);
          this.estateControlService.showChecklist = false;
        }
      }
    } else {
      this.initLocal();
    }
  }

  // Session info Popup
  openInfoModal = (): void => {
    const dialogRef = this.dialog.open(ModalComponent, {
      maxWidth: '500px',  // Maximum width of the modal
      height: 'fit-content',
      maxHeight: '1100px',
      data: {
        contentTemplate: this.modalContent,
        modalTitle: 'Welcome To Estate Planning',
        buttonText: 'Okay'
      },
      disableClose: true // Disable closing when clicking outside the modal
    });

    this.notificationService.addModal(dialogRef);

    dialogRef.afterClosed().subscribe(() => {
      this.notificationService.removeModal(dialogRef);
      this.hasInfoPopupRun = true;
    });
  }

  navHome(): void {
    const nextPage = ``;
    if (this.session == '') {this.router.navigate([nextPage]);}
    else {this.router.navigate([nextPage], {queryParams: {session: this.session}});}
  }

}
